module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', {
    attrs: {
      "title": "Preço único"
    }
  }, [_c('form-group', {
    attrs: {
      "label": "Utilizar preço único"
    }
  }, [_c('label', {
    staticClass: "form-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.useUniquePrice),
      expression: "useUniquePrice"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.useUniquePrice) ? _vm._i(_vm.useUniquePrice, null) > -1 : (_vm.useUniquePrice)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.useUniquePrice,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.useUniquePrice = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.useUniquePrice = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.useUniquePrice = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "form-switch__indicator"
  })]), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Define se será utilizado preço único para todas variações.")])]), _vm._v(" "), (_vm.price && _vm.useUniquePrice) ? _c('product-price-unique', {
    attrs: {
      "input": _vm.price,
      "module": _vm.fromModule || _vm.product.source,
      "sku": _vm.product.variations[0].sku
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a0f4695c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/shared/ProductEditBulkPrice.vue
// module id = 3384
// module chunks = 0